import dayjs from 'dayjs';
import type { Dayjs } from 'dayjs';

export enum DateFormat {
  Date = 'DD.MM.YYYY.',
  DateWithDash = 'YYYY-MM-DD',
  YearAndMonth = 'YYYY-MM',
  MonthYear = 'MMMM YYYY',
  DayMonth = 'DD.MM.',
  DateForQueryParam = 'YYYY-MM-DD',
  DateAndTime = 'DD.MM.YYYY, HH:mm',
  DateAndTimeSecond = 'DD.MM.YYYY, hh:mm:ss',
  Time = 'HH:mm',
}

export const dateFormat = (
  date: string | Dayjs,
  format: DateFormat = DateFormat.DateAndTime
): string | null => {
  if (!date) {
    return null;
  }

  return dayjs(date).format(format) as string;
};
